// i18n.ts
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import pl from './translations/pl.json'
import en from './translations/en.json'
import ru from './translations/ru.json'
import ua from './translations/ua.json'
import { LOCAL_STORAGE_LANG_KEY } from '@/lib/constants/constants.ts'

const resources = {
  en: { translation: en },
  pl: { translation: pl },
  ua: { translation: ua },
  ru: { translation: ru },
}

const savedLang =
  typeof window !== 'undefined' ? localStorage.getItem(LOCAL_STORAGE_LANG_KEY) : null

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang || 'pl',
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', lng => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(LOCAL_STORAGE_LANG_KEY, lng)
  }
})

export default i18n
